import { Routes } from "@angular/router";

import { ContentComponent } from "./shared/components/layout/content/content.component";
import { content } from "./shared/routes/content.routes";
import { LoginComponent } from "./components/auth/login/login.component";
import { authGuard } from "./shared/guard/auth.guard";
import { permissionGuard } from "./shared/guard/permission.guard";

export const routes: Routes = [
  {
    path: "",
    redirectTo: "/reservations",
    pathMatch: "full",
  },
  {
    path: "auth/login",
    component: LoginComponent,
  },
  {
    path: "",
    component: ContentComponent,
    canActivate: [authGuard, permissionGuard],
    children: [
      ...content,
      {
        path: "reservations",
        data: {
          breadcrumb: "Reservaciones",
        },
        children: [
          {
            path: "",
            loadComponent: () =>
              import(
                "./components/reservations/dashboard/reservations-dashboard.component"
              ).then((m) => m.ReservationsDashboardComponent),
            data: {
              title: "Reservaciones",
              breadcrumb: "Reservaciones",
            },
          },
          {
            path: "list",
            loadComponent: () =>
              import("./components/reservations/reservations.component").then(
                (m) => m.ReservationsComponent,
              ),
            data: {
              title: "Reservaciones",
              breadcrumb: "Detalles",
            },
          },
        ],
      },
      {
        path: "wallets",
        data: {
          breadcrumb: "Wallet de clientes",
        },
        children: [
          {
            path: "",
            loadComponent: () =>
              import(
                "./components/wallets/dashboard/wallets-dashboard.component"
              ).then((m) => m.WalletsDashboardComponent),
            data: {
              title: "Wallet de clientes",
              breadcrumb: "Wallet de clientes",
            },
          },
          {
            path: "list",
            loadComponent: () =>
              import("./components/wallets/wallets.component").then(
                (m) => m.WalletsComponent,
              ),
            data: {
              title: "Wallet de clientes",
              breadcrumb: "Listado",
            },
          },
          {
            path: ":userId",
            loadComponent: () =>
              import(
                "./components/wallets/detail/wallet-detail.component"
              ).then((m) => m.WalletDetailComponent),
            data: {
              title: "Wallet de clientes",
              breadcrumb: "Detalle de wallet",
            },
          },
        ],
      },
      {
        path: "branches",
        loadComponent: () =>
          import("./components/branches/branches.component").then(
            (m) => m.BranchesComponent,
          ),
      },
      {
        path: "currencies",
        loadComponent: () =>
          import("./components/currencies/currencies.component").then(
            (m) => m.CurrenciesComponent,
          ),
      },
      {
        path: "users",
        loadComponent: () =>
          import("./components/users/users.component").then(
            (m) => m.UsersComponent,
          ),
      },
      {
        path: "promotions",
        loadComponent: () =>
          import("./components/promotions/promotions.component").then(
            (m) => m.PromotionsComponent,
          ),
      },
      {
        path: "puntos",
        loadComponent: () =>
          import("./components/points/points.component").then(
            (m) => m.PointsComponent,
          ),
      },
      {
        path: "point-rules",
        loadComponent: () =>
          import(
            "./components/point-rules/dashboard/point-rules-dashboard.component"
          ).then((m) => m.PointRulesDashboardComponent),
        data: {
          title: "Matriz de Puntos",
          breadcrumb: "Matriz de Puntos",
        },
      },
      {
        path: "marketplace",
        loadComponent: () =>
          import(
            "./components/marketplace/dashboard/marketplace-dashboard.component"
          ).then((m) => m.MarketplaceDashboardComponent),
        data: {
          title: "Marketplace de Recompensas",
          breadcrumb: "Marketplace de Recompensas",
        },
      },
      {
        path: "referrals/config",
        loadComponent: () =>
          import(
            "./components/referrals/referral-config/referral-config.component"
          ).then((m) => m.ReferralConfigComponent),
      },
      {
        path: "referrals/tracking",
        loadComponent: () =>
          import(
            "./components/referrals/referral-tracking/referral-tracking.component"
          ).then((m) => m.ReferralTrackingComponent),
      },
      {
        path: "roles",
        loadComponent: () =>
          import("./components/access/roles/roles.component").then(
            (m) => m.RolesComponent,
          ),
        data: {
          title: "Roles",
          breadcrumb: "Roles",
        },
      },
      {
        path: "team",
        children: [
          {
            path: "",
            loadComponent: () =>
              import("./components/access/team/team.component").then(
                (m) => m.TeamComponent,
              ),
            data: {
              title: "Directorio de Equipo",
              breadcrumb: "Equipo",
              hideBreadcrumb: true,
            },
          },
          {
            path: ":memberId",
            loadComponent: () =>
              import("./components/access/team/team-profile/team-profile.component").then(
                (m) => m.TeamProfileComponent,
              ),
            data: {
              title: "Perfil de Colaborador",
              breadcrumb: "Perfil",
              hideBreadcrumb: true,
            },
          },
        ],
      },
      {
        path: "metric-exclusions",
        loadComponent: () =>
          import(
            "./components/metric-exclusions/metric-exclusions.component"
          ).then((m) => m.MetricExclusionsComponent),
        data: {
          title: "Exclusión de Correos en Métricas",
          breadcrumb: "Exclusión en Métricas",
          hideBreadcrumb: true,
        },
      },
      {
        path: "operating-hours",
        data: {
          breadcrumb: "Horarios",
          title: "Horarios y estados operativos",
        },
        children: [
          {
            path: "",
            loadComponent: () =>
              import("./components/operating-hours/operating-hours.component").then(
                (m) => m.OperatingHoursComponent,
              ),
            data: {
              title: "Horarios y estados operativos",
              breadcrumb: "Horarios de sucursales",
            },
          },
          {
            path: ":branchId",
            loadComponent: () =>
              import(
                "./components/operating-hours/detail/operating-hours-detail.component"
              ).then((m) => m.OperatingHoursDetailComponent),
            data: {
              title: "Horarios y estados operativos",
              breadcrumb: "Sucursal",
            },
          },
        ],
      },
      {
        path: "settings/notifications",
        loadComponent: () =>
          import(
            "./components/settings/notifications/notifications-settings.component"
          ).then((m) => m.NotificationsSettingsComponent),
        data: {
          title: "Notificaciones",
          breadcrumb: "Notificaciones",
        },
      },
      {
        path: "settings",
        loadComponent: () =>
          import("./components/settings/settings.component").then(
            (m) => m.SettingsComponent,
          ),
        data: {
          title: "Configuración",
          breadcrumb: "General",
        },
      },
      {
        path: "legal",
        loadComponent: () =>
          import("./components/legal/legal.component").then(
            (m) => m.LegalComponent,
          ),
      },
      {
        path: "app-tokens",
        loadComponent: () =>
          import("./components/app-tokens/app-tokens.component").then(
            (m) => m.AppTokensComponent,
          ),
      },
      {
        path: "core-environments",
        loadComponent: () =>
          import("./components/core-environments/core-environments.component").then(
            (m) => m.CoreEnvironmentsComponent,
          ),
      },
      {
        path: "webhook-subscriptions",
        loadComponent: () =>
          import("./components/webhook-subscriptions/webhook-subscriptions.component").then(
            (m) => m.WebhookSubscriptionsComponent,
          ),
      },
    ],
  },
];
